var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#FF2D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 18.6455C12.4033 18.6455 9.33325 19.2122 9.33325 21.4788C9.33325 23.7463 12.3841 24.333 15.9974 24.333C19.5916 24.333 22.6616 23.7672 22.6616 21.4997C22.6616 19.2322 19.6116 18.6455 15.9974 18.6455Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9974 16.4865C18.4457 16.4865 20.4074 14.524 20.4074 12.0765C20.4074 9.629 18.4457 7.6665 15.9974 7.6665C13.5499 7.6665 11.5874 9.629 11.5874 12.0765C11.5874 14.524 13.5499 16.4865 15.9974 16.4865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreProfile);
export default __webpack_public_path__ + "static/media/store-profile.12a16e66ef890282afdfc7fbca544bfc.svg";
export { ForwardRef as ReactComponent };